module.exports = __webpack_public_path__ + "img/payment.f954a3ff.png";